<template>
  <a-modal v-model="visible" :title="$t('申请_放箱单延期申请')" wrap-class-name="apply-release-order-delay-modal" width="800px" @ok="submit">
    <div class="release-info" v-if="order">
      <h4>{{ $t('packingList') }}：{{order.SEND_CODE}}</h4>
      <a-row :gutter="20">
        <a-col :span="12">{{ $t('通用_有效期') }}：{{ $moment(order.XE_BEGIN_DATE).format('YYYY-MM-DD') }} ~ {{ $moment(order.XE_END_DATE).format('YYYY-MM-DD') }}</a-col>
        <a-col :span="12">{{ $t('通用_箱型') }}：{{ $dt(order, 'BOX_SIZE_NAME') }}</a-col>
        <a-col :span="12">{{ $t('通用_堆场') }}：{{ $dt(order, 'XE_SPACE_NAME') }}</a-col>
      </a-row>
    </div>
    <a-form-model class="margin-top-10" :model="editForm" layout="vertical">
      <a-row :gutter="20">
        <a-col :span="12">
          <a-form-model-item :label="$t('extensionDate')" prop="DELAY_END_DATE">
            <dol-date v-model="editForm.DELAY_END_DATE" />
          </a-form-model-item>
        </a-col>
        <a-col :span="24">
          <a-form-model-item :label="$t('delayReason')" prop="DELAY_DESC">
            <a-textarea v-model="editForm.DELAY_DESC" :auto-size="{minRows: 3}" />
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
  </a-modal>
</template>

<script>
export default {
  name: 'apply-release-order-delay-modal',
  data () {
    return {
      visible: false,
      boxList: [],
      editForm: {},
    };
  },
  computed: {
    order(){
      if(this.boxList.length === 0) return null;
      return this.boxList[0];
    },
  },
  methods: {
    open(boxList){
      this.boxList = boxList;
      this.editForm = {};
      this.visible = true;
    },
    submit(){

    },
  },
};
</script>

<style lang="scss">
.apply-release-order-delay-modal{
  .release-info{
    padding: 20px;
    background: #F5F7F9;
    border-radius: 4px;
    border: 1px solid #E5E5E5;
  }
}
</style>